// ** Styles
import { DIN } from '@/styles/globalStyles';

// ─── sx style objects ─────────────────────────────────────────────────────────

// Colors are intentionally kept as raw hex values because these objects are
// consumed by both MUI sx props and ApexCharts config (which needs raw CSS strings,
// not MUI theme tokens). They map to: text.secondary (#353535) and common.black (#000).

// Matches the theme 'label' variant — used for axis tick values and table cell text.
export const axisValueSx = {
	color: '#353535',
	fontFamily: DIN,
	fontSize: '14px',
	fontWeight: 400,
	lineHeight: '24px',
	letterSpacing: '-0.05px'
};

// Used for axis titles and table column headers (10px, medium weight).
export const axisTitleSx = {
	color: '#000',
	fontFamily: DIN,
	fontSize: '10px',
	fontStyle: 'normal' as const,
	fontWeight: 500,
	lineHeight: '10px',
	letterSpacing: '-0.2px'
};
